import { CustomMenuItemType } from '../custom-menu-items-type'

export function isMenuItemType(item: any): item is CustomMenuItemType<'item'> {
  return (
    item &&
    (item.type === 'item' || (item.type === undefined && !item.children))
  )
}

export function isSubOrGroupOrDynamicMenuType(
  item: any
): item is CustomMenuItemType<'submenu' | 'group' | 'dynamic'> {
  return item && !!item.children
}

export function isSubMenuType(
  item: any
): item is CustomMenuItemType<'submenu'> {
  return (
    item &&
    (item.type === 'sub' ||
      (!!item.children && (item.type !== 'group' || item.type !== 'dynamic')))
  )
}

export function isGroupMenuType(
  item: any
): item is CustomMenuItemType<'group'> {
  return item && item.type === 'group'
}

export function isMenuDividerType(
  item: any
): item is CustomMenuItemType<'divider'> {
  return item && item.type === 'divider'
}

export function isDynamicMenuType(
  item: any
): item is CustomMenuItemType<'dynamic'> {
  return item && item.type === 'dynamic'
}
